

















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch, Prop } from 'vue-property-decorator'
import IconBase from '../icons/IconBase.vue'
import IconToggle from '../icons/IconToggle.vue'
import SelfCheckProgressCell, { ISelfCheckAnswer } from './SelfCheckProgressCell.vue'
import { Setting } from '@/setting'

@Component({
  components: {
    IconBase,
    IconToggle,
    SelfCheckProgressCell
  }
})
export default class SelfCheckProgress extends Vue {
  @Prop() selfcheckObj: any;
  @Prop() encourageMailStatusObj: any;
  @Prop() sc0wIsOpened?: boolean;
  @Prop() userId?: string;

  selfcheckAnswers: Array<ISelfCheckAnswer> = []
  assigned: boolean = false
  answeredAfterCoreWeeks: boolean = false
  showAfterCoreWeeks: boolean = false
  encourageMailStatusWeek0: boolean = false
  encourageMailStatus: Array<boolean> = []

  @Watch('encourageMailStatusObj')
  onChangeEncourageMailStatusObj () {
    this.refleshEncourageMailStatus()
  }

  @Watch('selfcheckObj')
  onChangeSelfCheckObj () {
    this.refleshSelfCheckObj()
  }

  get selfcheckBeforeAssigned () {
    return this.selfcheckAnswers.slice(
      Setting.SELFCHECK_ASSIGN_INDEX,
      Setting.SELFCHECK_ASSIGN_INDEX + 1
    )
  }

  get selfcheckCore () {
    const start = this.selfcheckAnswers.findIndex(e => e.answerIndex > Setting.SELFCHECK_ASSIGN_INDEX)
    const end = this.selfcheckAnswers.findIndex(e => e.answerIndex === Setting.SELFCHECK_CORE_INDEX)
    return this.selfcheckAnswers.slice(start, end + 1)
  }

  get selfcheckAfterCore () {
    const start = this.selfcheckAnswers.findIndex(e => e.answerIndex > Setting.SELFCHECK_CORE_INDEX)
    return this.selfcheckAnswers.slice(start)
  }

  hasEncourageMailCheck (index: number) {
    return Setting.ENCOURAGE_MAIL_INDEXES.some(v => v === index)
  }

  beforeMount () {
    this.refleshEncourageMailStatus()
    this.refleshSelfCheckObj()
  }

  refleshEncourageMailStatus () {
    if (this.encourageMailStatusObj !== undefined && this.encourageMailStatusObj !== null) {
      this.encourageMailStatusWeek0 = this.encourageMailStatusObj[0]
      this.encourageMailStatus = this.encourageMailStatusObj.slice(1, this.encourageMailStatusObj.length)
    } else {
      this.encourageMailStatusWeek0 = false
      this.encourageMailStatus = Array(Setting.SELFCHECK_LAST_INDEX + 1).fill(false)
    }
  }

  refleshSelfCheckObj () {
    this.selfcheckAnswers = this.selfcheckObj !== undefined ? this.selfcheckObj : []
    if (this.selfcheckAnswers.length > 1) {
      this.assigned = true
      this.answeredAfterCoreWeeks = false
      const index = this.selfcheckAnswers.findIndex(e => e.answerIndex > Setting.SELFCHECK_CORE_INDEX)
      if (index > -1) {
        const afterCoreAnswer = this.selfcheckAnswers[index]
        if (afterCoreAnswer.canAnswerAt !== null && index < Setting.SELFCHECK_DEADLINE_DAYS.length) {
          // コアアンケートの次のアンケートの回答期限をすぎるか回答しているか、回答済みかどうか
          const terms = Setting.SELFCHECK_DEADLINE_DAYS[index] * 1000 * 60 * 60 * 24
          const isAfterCoreWeek = new Date(afterCoreAnswer.canAnswerAt).getTime() + terms <= new Date().getTime()
          const isAnsweredCoreWeek = afterCoreAnswer.survey.PHQ9 && afterCoreAnswer.survey.PHQ9.answeredAt !== null
          if (isAfterCoreWeek || isAnsweredCoreWeek) {
            this.answeredAfterCoreWeeks = true
          }
        }
      } else {
        console.log('after core self checks are none.')
      }
      this.showAfterCoreWeeks = this.answeredAfterCoreWeeks
    } else if (this.selfcheckAnswers.length === 1) {
      // 0週のセルフチェックが回答済みで未割付の場合
      this.assigned = false
      this.showAfterCoreWeeks = false
      this.answeredAfterCoreWeeks = false
    } else if (this.selfcheckAnswers.length === 0) {
      // 0週のセルフチェックが未回答の場合
      this.assigned = false
      this.showAfterCoreWeeks = false
      this.answeredAfterCoreWeeks = false
      this.selfcheckAnswers.push({
        answerIndex: 0,
        survey: {
          PHQ9: {
            answeredAt: null
          }
        },
        canAnswerAt: null,
        alert: false
      })
    }
  }

  onEncourageMailStatusChange () {
    this.$emit('encourageMailStatusChange', [this.encourageMailStatusWeek0].concat(this.encourageMailStatus))
  }
}

